<div class="documents-header">
  <div class="page-title">Audit Logs</div>
  <div class="page-size">
    <app-page-size
      [pageSize]="pageSize"
      [pageSizeOptions]="[50, 100, 150, 200]"
      [selectId]="'audit-logs-page-size'"
      (pageSizeChanged)="onPageSizeChange($event)"
    ></app-page-size>
  </div>
</div>

<div class="filter-search-section">
  <div class="filter-left-container">
    <app-filter-group
      [label]="'Filters'"
      [hasActiveFilters]="hasActiveFilters"
      [activeFilters]="activeFilters"
      (filterRemoved)="removeFilter($event)"
    >
      <div class="filter-section">
        <div class="filter-section-title">Date Range</div>
        <div class="filter-row">
          <div class="filter-group">
            <label for="startDate">Start Date</label>
            <input type="date" id="startDate" [(ngModel)]="startDate" />
          </div>
          <div class="filter-group">
            <label for="endDate">End Date</label>
            <input type="date" id="endDate" [(ngModel)]="endDate" />
          </div>
        </div>
        @if (dateValidationError) {
          <div class="validation-error">{{ dateValidationError }}</div>
        }
      </div>

      <div class="filter-divider"></div>

      <div class="filter-section">
        <div class="filter-section-title">Log Details</div>
        <div class="filter-row">
          <div class="filter-group">
            <label for="connectionName">Connection Name</label>
            <select
              id="connectionName"
              [(ngModel)]="connectionName"
              (ngModelChange)="onConnectionFilterChange()"
            >
              <option value="">All</option>
              @for (connection of connections; track connection.id) {
                <option [value]="connection.name">
                  {{ connection.display_name || connection.name }}
                </option>
              }
            </select>
          </div>
          <div class="filter-group">
            <label for="userId">
              User
              @if (!connectionName) {
                <span class="field-hint">(Select Connection first)</span>
              }
            </label>
            <select
              id="userId"
              [(ngModel)]="userId"
              [disabled]="!connectionName"
            >
              <option value="">All</option>
              @for (user of users; track user.id) {
                <option [value]="user.id">
                  {{ user.first_name }} {{ user.last_name }}
                </option>
              }
            </select>
          </div>
          <div class="filter-group">
            <label for="source">Source</label>
            <select id="source" [(ngModel)]="source">
              <option value="">All</option>
              <option value="Server-side">Server-side</option>
              <option value="Client-side">Client-side</option>
            </select>
          </div>
        </div>
      </div>

      <div class="filter-actions">
        <button class="btn-clear" (click)="clearFilters()">Clear</button>
        <button class="btn-apply" (click)="applyFilters()">Apply</button>
      </div>
    </app-filter-group>
  </div>
</div>

<div class="audit-logs-wrapper">
  <div class="table-container">
    <app-table
      [columns]="columns"
      [data]="auditLogs"
      [loading]="isLoadingResults"
      [noResultsMessage]="'No logs found.'"
    >
      <ng-template let-log>
        <tr>
          <td>{{ log.timestamp | date: "medium" }}</td>
          <td>
            @if (log.user) {
              {{ log.user.first_name }} {{ log.user.last_name }}
            } @else {
              System
            }
          </td>
          <td>{{ log.connection_display_name || log.connection_name }}</td>
          <td>{{ log.source }}</td>
          <td>{{ log.feature_name }}</td>
          <td>{{ log.action }}</td>
          <td>{{ log.ip_address || "N/A" }}</td>
          <td>{{ log.description }}</td>
          <td style="text-align: center">
            <button
              class="btn-view-meta"
              (click)="openMetaPopup(log.id)"
              title="View Info"
            >
              <app-svg-icon
                [iconName]="'info.svg'"
                [width]="'16px'"
                [height]="'16px'"
              ></app-svg-icon>
            </button>
          </td>
        </tr>
      </ng-template>
    </app-table>
  </div>
</div>

@if (totalCount > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalCount"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (showMetaPopup) {
  <app-popup
    [heading]="'Metadata Details'"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    (cancelClicked)="closeMetaPopup()"
  >
    <div class="meta-container">
      <div class="meta-actions">
        @if (selectedMeta) {
          <button
            class="btn-copy"
            (click)="copyToClipboard()"
            [title]="copySuccess ? 'Copied!' : 'Copy to clipboard'"
          >
            <app-svg-icon
              [iconName]="copySuccess ? 'check-simple.svg' : 'copy.svg'"
              [width]="'14px'"
              [height]="'14px'"
            ></app-svg-icon>
            <span>{{ copySuccess ? "Copied!" : "Copy" }}</span>
          </button>
        }
      </div>
      <div class="meta-json-viewer">
        @if (selectedMeta) {
          <pre><code>{{ selectedMeta | json }}</code></pre>
        } @else {
          <div class="no-meta-text">No metadata available.</div>
        }
      </div>
    </div>
  </app-popup>
}
